import { render, staticRenderFns } from "./fixedBottom.vue?vue&type=template&id=298bed8a&"
import script from "./fixedBottom.vue?vue&type=script&lang=ts&"
export * from "./fixedBottom.vue?vue&type=script&lang=ts&"
import style0 from "./fixedBottom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports